import { Validation } from '../../../../types/Validation';

// eslint-disable-next-line no-magic-numbers
export const genderIds = [0, 1, 2, 3, 9] as const;

export type GenderId = (typeof genderIds)[number];

const genderLabels = ['未選択', '男性', '女性', 'その他'] as const;

type GenderLabel = (typeof genderLabels)[number];

export const isGenderId = (value: unknown): value is GenderId => {
  if (typeof value !== 'number') {
    return false;
  }

  return genderIds.includes(value as GenderId);
};

type GenderAttribute = {
  key: number;
  value: string;
  label: GenderLabel;
};

export const createGenderAttributes = (): GenderAttribute[] => [
  {
    key: 1,
    value: '0',
    label: '未選択',
  },
  {
    key: 2,
    value: '2',
    label: '女性',
  } as const,
  {
    key: 3,
    value: '1',
    label: '男性',
  } as const,
  {
    key: 4,
    value: '9',
    label: 'その他',
  } as const,
];

type GenderValidator = Validation<{ name: 'gender'; reason: string }>;

// eslint-disable-next-line require-await
export const genderValidator: GenderValidator = async (value: unknown) => {
  if (isGenderId(value)) {
    return { isValidate: true };
  }

  return {
    isValidate: false,
    invalidParams: [{ name: 'gender', reason: '性別の値が不正です。' }],
  };
};
